var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-top-bar"},[_c('div',{staticClass:"top-bar-image"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"Top Bar Icon"}})]),_vm._v(" "),_c('div',{staticClass:"page-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a3f6da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Inputs/generalTopBar.vue
// module id = bQL1
// module chunks = 1